import { Component, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { ChangeLanguageService } from 'app/core/util/change-language.service';

@Component({
  selector: 'cbic-static-text',
  templateUrl: './static-text.component.html',
  styleUrls: ['./static-text.component.css']
})

export class StaticTextComponent{
  @Input() textEn: any;
  @Input() textHi: any;
  @Input() html = false;
  @Input() trimContent = false;
  @Input() trimCharsLimit = 100;
  @Input() trimmed = false;
  
  lang = 'en';
  constructor(
    private changeLnService: ChangeLanguageService,
    private sanitizer:DomSanitizer,
    private modalService: NgbModal,
    config: NgbModalConfig,
  ){
    config.backdrop = 'static';
    config.keyboard = false;
  }
  
  getText(trim = true): any{
    let text:string = this.textEn;
    if(this.changeLnService.getLanguage() === 'hi' && this.textHi){
      text = this.textHi;
    }
    if(this.html){
      return this.sanitizer.bypassSecurityTrustHtml(text??"");
    }

    
    if(trim && text && this.trimContent){
      if(!this.trimCharsLimit || this.trimCharsLimit === 0){
        this.trimCharsLimit = 100;
      }
      if(text.length > this.trimCharsLimit){
        text = text.substring(0, this.trimCharsLimit);
        this.trimmed = true;
      }
    }
    return text;
  }

  
  showCompleteData(): void{
    const modal = this.modalService.open(ShowTextModalComponent, {centered: true});
    modal.componentInstance.text = this.getText(false);
    modal.componentInstance.modalRef = modal;
  }
}

@Component({
  selector: 'cbic-show-text-popup',
  template: `
  <div class='modal-content'>
    <div class='modal-header'>
      <button type="button" class="btn-close" aria-label="Close" (click)="modalRef.dismiss('Cross click')"></button>
    </div>
    <div class='modal-body customizeHeight1 custom-scroll-bar'>
      {{text}}
    </div>
  </div>
  `
})
export class ShowTextModalComponent{
  @Input() text: any;
  @Input() modalRef: any;
}